module.exports = __webpack_public_path__ + "static/media/manila.6d69cde0.svg";